import { Breadcrumb, Layout, Spin, Form, Input, DatePicker, Button, Row, Col, Card, message, Select } from 'antd';
import { Content } from 'antd/es/layout/layout';
import Headerdiv from '../../layout/header';
import Footerdiv from '../../layout/footer';
import { Link, useNavigate } from 'react-router-dom';
import { useState, useEffect } from 'react';
import axiosClient from '../../../api/axiosClient';
import { APPBACKGROUND_COLOR } from '../../appsettings';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';

const { TextArea } = Input;

const CreateRecord = () => {
    const [form] = Form.useForm();
    const USERID = localStorage.getItem("USERID");
    const [loading, setLoading] = useState(false);
    const [inventoryItems, setInventoryItems] = useState([]);
    const navigate = useNavigate();

    const fetchInventoryItems = async () => {
        try {
            const response = await axiosClient.get('/inventory/get_all_inventory_dropdown.php');
            const result = response.data;

            if (result.status === 'success') {
                setInventoryItems(result.data);
            } else {
                message.error(result.message || 'Failed to fetch inventory items.');
            }
        } catch (error) {
            console.error('Fetch inventory items error:', error);
            message.error(error.response?.data?.message || 'Network error.');
        }
    };

    useEffect(() => {
        fetchInventoryItems();
    }, []);

    const onFinish = async (values) => {
        setLoading(true);
        const payload = {
            ...values,
            date: values.date ? values.date.format("YYYY-MM-DD") : null,
            by: USERID
        };

        try {
            const response = await axiosClient.post('/inventory/record/add_record.php', payload);
            const data = response.data;

            if (data.status === "success") {
                message.success(data.message);
                form.resetFields();
                navigate('/inventory/records'); // Assuming a records list page exists
            } else {
                message.error(data.message || "Failed to create record.");
            }
        } catch (error) {
            console.error("API Error:", error);
            message.error(error.response?.data?.message || "Failed to connect to server.");
        } finally {
            setLoading(false);
        }
    };

    return (
        <Spin spinning={loading} tip="Saving Record...">
            <Layout style={{ backgroundColor: APPBACKGROUND_COLOR, minHeight: '100vh' }}>
                <Headerdiv />
                <Content style={{ padding: "10px" }}>
                    <Breadcrumb style={{ marginBottom: 10 }}>
                        <Breadcrumb.Item><Link to={"/inventory/itemList"}>Inventory</Link></Breadcrumb.Item>
                        <Breadcrumb.Item><Link to={"/inventory/records"}>Records</Link></Breadcrumb.Item>
                        <Breadcrumb.Item>Create Record</Breadcrumb.Item>
                    </Breadcrumb>

                    <Form layout="vertical" form={form} onFinish={onFinish}>
                        <Card title="Record Information">
                            <Row gutter={[16, 16]}>
                                <Col xs={24} sm={12} md={6}>
                                    <Form.Item
                                        name="inventory_id"
                                        label="Inventory Item"
                                        rules={[{ required: true, message: "Inventory Item is required" }]}
                                    >
                                        <Select placeholder="Select Inventory Item" showSearch optionFilterProp="children">
                                            {inventoryItems.map((item) => (
                                                <Select.Option key={item.id} value={item.id}>
                                                    {item.item_code} - {item.value}
                                                </Select.Option>
                                            ))}
                                        </Select>
                                    </Form.Item>
                                </Col>

                                <Col xs={24} sm={12} md={6}>
                                    <Form.Item
                                        name="type"
                                        label="Type"
                                        rules={[{ required: true, message: "Type is required" }]}
                                    >
                                        <Select placeholder="Select Type" showSearch optionFilterProp="children">
                                            <Select.Option value="Breakdown">Breakdown</Select.Option>
                                            <Select.Option value="Repair">Repair</Select.Option>
                                            <Select.Option value="Service">Service</Select.Option>
                                            <Select.Option value="Other">Other</Select.Option>
                                        </Select>
                                    </Form.Item>
                                </Col>

                                <Col xs={24} sm={12} md={6}>
                                    <Form.Item
                                        name="date"
                                        label="Date"
                                        rules={[{ required: true, message: "Date is required" }]}
                                    >
                                        <DatePicker style={{ width: "100%" }} />
                                    </Form.Item>
                                </Col>

                                <Col xs={24} sm={12} md={6}>
                                    <Form.Item
                                        name="status"
                                        label="Status"
                                        rules={[{ required: true, message: "Status is required" }]}
                                        initialValue="Open"
                                    >
                                        <Select placeholder="Select Status">
                                            <Select.Option value="Open">Open</Select.Option>
                                        </Select>
                                    </Form.Item>
                                </Col>

                                <Col xs={24}>
                                    <Form.Item name="description" label="Description">
                                        <ReactQuill theme="snow" placeholder="Enter Description" />
                                    </Form.Item>
                                </Col>

                                <Col xs={24}>
                                    <Form.Item name="note" label="Note">
                                        <TextArea rows={2} placeholder="Enter Note" />
                                    </Form.Item>
                                </Col>

                                <Col xs={24}>
                                    <Row justify="end" gutter={[10, 10]} style={{ marginTop: 10 }}>
                                        <Col>
                                            <Button onClick={() => form.resetFields()}>Clear</Button>
                                        </Col>
                                        <Col>
                                            <Button type="primary" htmlType="submit">
                                                Save Record
                                            </Button>
                                        </Col>
                                    </Row>
                                </Col>
                            </Row>
                        </Card>
                    </Form>
                </Content>
                <Footerdiv />
            </Layout>
        </Spin>
    );
};

export default CreateRecord;
